import dayjs from "dayjs";

/** Rolling window for student-logged activity dates (matches sva-api config). */
export const STUDENT_ACTIVITY_HISTORY_MONTHS = 12;

export const earliestActivityDate = () =>
  dayjs().subtract(STUDENT_ACTIVITY_HISTORY_MONTHS, "month");

export const activityHistoryDateMessage = () =>
  `Session must be within the last ${STUDENT_ACTIVITY_HISTORY_MONTHS} months`;

/**
 * True when a date falls outside the normal logging window. Sessions like this are
 * still accepted (not blocked) but get flagged for teacher/SVA review by the API.
 */
export const isBacklogDate = (date) => !!date && dayjs(date).isBefore(earliestActivityDate());
